/**
 * Capitalize the first letter of a string and lowercase the rest.
 * @param value - The string to capitalize
 * @returns The capitalized string
 */
export const capitalize = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
